<template>
  <div class="shop" ref="shopRef">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="吉品兑换"></Header>
    <div class="content" ref="contentRef" style="background-color: #ffffff">
      <cube-scroll ref="scrollRef" :options="scrollOptions" @pulling-down="onPullingDown">
        <section class="itemWrapper">
          <div class="shopItem"
               v-for="item in goodsList"
               :key="item.id"
               style="margin-bottom: 15px;"
               @click="gotoPage(`/shopDetail/${item.id}`, `/pages/product/product?id=${item.id}`)">
            <img v-if="item.coverUrl" class="shopImage" :src="item.coverUrl" />
            <div v-else class="no-img">暂无图片</div>
            <div class="integral text-ellipsis-single" style="font-size: 14px; height: 20px; line-height: 20px;">{{ item.name }}</div>
            <div class="integral" style="margin-top: 4px; font-size: 12px;">{{item.value}}积分</div>
          </div>
        </section>
      </cube-scroll>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header'
import { queryGoodsList } from '@/api/shop'

export default {
  name: 'Shop',
  components: {
    Header
  },
  data: function () {
    return {
      scrollOptions: {
        pullDownRefresh: {
          txt: '刷新成功'
        }
      },
      goodsList: [{
        id: '',
        coverUrl: '',
        name: '',
        value: ''
      }]
    }
  },
  mounted () {
    document.title = '吉品兑换'

    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.contentRef.style.height = (this.$refs.shopRef.clientHeight - navBarHeight) + 'px'
    })

    this.getData()
  },
  methods: {
    onPullingDown () {
      // 模拟更新数据
      this.getData()
      setTimeout(() => {
        console.log('更新数据。。。')
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },
    getData () {
      queryGoodsList({
        page: 1,
        size: 100
      }).then((res) => {
        this.goodsList.splice(0)
        const records = res.data.records
        records.sort(this.compare('sort'))
        records.forEach((item, idx) => {
          const goods = {
            id: item.goodsId,
            coverUrl: item.cover.resUrl,
            name: item.name,
            value: item.value
          }
          this.goodsList.push(goods)
        })
      })
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },

    gotoPage (url, miniUrl) {
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.navigateTo({ url: miniUrl })
      } else {
        this.$router.push({ path: url })
      }
    }
  }
}
</script>
<style lang="stylus" scpope>
.shop
  height 100%
.itemWrapper
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 7px;
  background-color #fff
  .shopItem
    width: 110px;
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    justify-content: center;
    .shopImage
      height: 110px;
      width: 110px;
      object-fit cover
    .integral
      color: #545454;
      margin-top: 10px;
      font-weight:400;
    .no-img
      height: 110px;
      width: 110px;
      border 1px solid #E2E2E2
      display flex
      align-items center
      justify-content center
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
